import jQuery from "jquery";
import View from "app/views/View";
import slick from "slick-carousel";

import renderTemplate from "@pch/nunjucks-extensions";
import AnimationUtil from "@pch/animatejs";
/**
 * This class represents a view for the check my numbers page
 */
let viewContext = null;

class CheckMyNumbersView extends View {
  init() {
    super.init();
  }

  mount(appCtx) {
    super.mount(appCtx);
    viewContext = this;
    this.currentGameId = null;
    this.gameData = {};
    this.deviceSelected = null;
    this.pickedDailyDate = undefined;
    this.isFirstGame = true;
    this.winningNumbersData = {};
    console.log("check my numbers view mounted");
    this.setupSlickSlider();
    this.setupMatchKey();
    this.setupHowItWorks();
    this.setupDeviceSelector();

    $(".cmn__your-numbers__selectors__selector__selectEl").on("click", function(
      event
    ) {
      event.preventDefault();
      $(this)
        .siblings("ul")
        .toggleClass("cmn__your-numbers__selectors__selector__optionsEl--open");
    });

    $(".cmn__your-numbers__selectors__selector__optionsEl").on(
      "click",
      "li:not(.cmn__your-numbers__selectors__selector__optionsEl__optionEl--disabled)",
      function(event) {
        event.preventDefault();
        viewContext.setSelectedDateTo($(this));
        viewContext.dateSelectedByUser($(this));
      }
    );
    this.setupFirstGameplayData();
  }

  setupSlickSlider() {
    let slickSliderParentEl = jQuery(".cmn__slider__holder");
    slickSliderParentEl.slick({
      arrows: !isMobile,
      centerMode: true,
      centerPadding: isMobile ? "15vw" : "100px",
      slidesToShow: 1,
      focusOnSelect: true
    });
    slickSliderParentEl.on("afterChange", function(event, slick, currentSlide) {
      this.currentSlide = currentSlide;
      viewContext.currentGameId = $(".slick-current").data("gameid");
      if (isMobile)
        $(".game-img").attr(
          "src",
          $(".slick-current .cmn__slider__holder__slide__img-wrapper img").attr(
            "src"
          )
        );
      if (!viewContext.isFirstGame) {
        viewContext.getGameData(viewContext.currentGameId, undefined);
      } else {
        viewContext.isFirstGame = false;
      }
      //this.getNewGameData();
      // left
    });

    let sliderLength = $(".cmn__slider__holder__slide").length;

    slickSliderParentEl.on("click", ".slick-slide", function(e) {
      if ($(this).hasClass("slick-current")) return false;

      // COMMENTED OUT BECAUSE THE focusOnSelect OPTION ABOVE FIXES THE ISSUE WHEN CLICKING ON THE CLONED ELEMENTS (USED TO APPEAR AS AN INFINITE SCROLL)
      // if ($(this).data("slick-index") < -1) {
      //   slickSliderParentEl[0].slick.slickGoTo(25);
      // } else {
      //   slickSliderParentEl[0].slick.slickGoTo($(this).data("slick-index"));
      // }

      //viewContext.currentGameId = $(this).data("gameid");
      //viewContext.getGameData(viewContext.currentGameId, undefined);
    });
  }

  setupDeviceSelector() {
    let deviceSelector = $("ul.o-grid__cell li");
    let deviceSelectorClass =
      "cmn__your-numbers__selectors__selector--device__selected";

    function initialDSSetup(el) {
      deviceSelector.removeClass(deviceSelectorClass);
      el.addClass(deviceSelectorClass);
      viewContext.deviceSelected = el.data("device").split("_");
    }
    deviceSelector.on("click", function() {
      initialDSSetup($(this));
      viewContext.filterDrawnData(viewContext.gameData);
    });
    window.isApp = window.location.href.indexOf("/appcheckmynumbers") != -1;
    if (isTablet) {
      //this.deviceSelected = "tablet";
      initialDSSetup($(deviceSelector.get(1)));
    } else if (isApp) {
      initialDSSetup($(deviceSelector.get(3)));
    } else if (isMobile) {
      //this.deviceSelected = "mobile";
      initialDSSetup($(deviceSelector.get(2)));
    } else {
      //else if(isApp){$(deviceSelector.get(3)).trigger('click');this.deviceSelected = 4;}
      //this.deviceSelected = "desktop";
      initialDSSetup($(deviceSelector.get(1)));
    }

    if (window.isMobile) {
      $(".cmn__your-numbers-mobile-date-select button").on("click", function(
        event
      ) {
        event.preventDefault();
        $(".cmn__your-numbers__selectors--mobile-wrapper").fadeIn();
      });
      $(".selector-ok-button").on("click", function(event) {
        event.preventDefault();
        $(".cmn__your-numbers__selectors--mobile-wrapper").fadeOut();
      });
    }
  }

  setupHowItWorks() {
    $(".cmn__header__heading-row__mk_hiw.hiw").on("click", function() {
      $(".cmn__matchkey__close").trigger("click");
      if ($(".cmn__howitworks").hasClass("cmn__howitworks--slidedown")) {
        $(".cmn__howitworks__close").trigger("click");
      } else {
        $(".cmn__howitworks").addClass("cmn__howitworks--slidedown");
      }
    });
    $(".cmn__howitworks__close").on("click", function(event) {
      event.preventDefault();
      $(".cmn__howitworks").removeClass("cmn__howitworks--slidedown");
    });
  }
  setupMatchKey() {
    $(".cmn__header__heading-row__mk_hiw.mk").on("click", function() {
      $(".cmn__howitworks__close").trigger("click");
      $(".cmn__your-numbers .c-overlay").removeClass("c-overlay--hidden");
      if (
        $(".cmn-matchkey-wrapper").hasClass("cmn-matchkey-wrapper--slidedown")
      ) {
        $(".cmn__matchkey__close").trigger("click");
      } else {
        $(".cmn-matchkey-wrapper").addClass("cmn-matchkey-wrapper--slidedown");
      }
    });

    $(".cmn__matchkey__close").on("click", function(event) {
      event.preventDefault();
      $(".cmn__your-numbers .c-overlay").addClass("c-overlay--hidden");
      $(".cmn-matchkey-wrapper").removeClass("cmn-matchkey-wrapper--slidedown");
      //setTimeout(function(){$(".cmn__howitworks").addClass("cmn__howitworks--visibility-hidden");}, 1000)
    });

    $(".site-menu__link--tour").on("click", function(event) {
      event.preventDefault();
      $(".cmn__matchkey__close").trigger("click");
    });
  }

  setupFirstGameplayData() {
    this.gameData = window.LOTTO_GLOBALS.CMN_INITIAL_DATA;
    //this.currentGameId = $(".slick-current").data("gameid");
    $(".start-game").trigger("click");
    this.processGameData(this.gameData);

    //this.isFirstGame = false;
  }

  toggleLoadingIcon(show = 0) {
    show
      ? $(".cmn__your-numbers").addClass("showLoader")
      : $(".cmn__your-numbers").removeClass("showLoader");
  }

  setSelectedDateTo(dateEl) {
    dateEl
      .parent()
      .find(".cmn__your-numbers__selectors__selector__optionsEl li")
      .removeClass(
        "cmn__your-numbers__selectors__selector__optionsEl__optionEl--selected"
      );
    dateEl.addClass(
      "cmn__your-numbers__selectors__selector__optionsEl__optionEl--selected"
    );
    dateEl
      .parent()
      .removeClass("cmn__your-numbers__selectors__selector__optionsEl--open")
      .siblings(".cmn__your-numbers__selectors__selector__selectEl")
      .find("div")
      .text(dateEl.find("div:nth-child(2)").text());
    if (
      window.isMobile &&
      dateEl
        .parent()
        .parent()
        .hasClass("cmn__your-numbers__selectors__selector--dailydrawing")
    ) {
      $(".cmn__your-numbers-mobile-date-select article").html(
        dateEl.find("div:nth-child(2)").text()
      );
    }
  }

  getWinningNumbersData() {
    let _selector = "";
    let _drawingData = [];
    if (viewContext.gameData.isWeeklyDrawing) {
      _selector = ".cmn__your-numbers__selectors__selector--weeklydrawing";
      _drawingData = viewContext.gameData.weeklydrawing;
    } else {
      _selector = ".cmn__your-numbers__selectors__selector--dailydrawing";
      _drawingData = viewContext.gameData.dailydrawing;
    }
    let _selectedDate = $(_selector)
      .find(
        ".cmn__your-numbers__selectors__selector__optionsEl__optionEl--selected div:nth-child(2)"
      )
      .data("date");
    //let _allDates = viewContext.gameData.isWeeklyDrawing ? viewContext.gameData.weeklydrawing : viewContext.gameData.dailydrawing;
    //let _PHPDate = dateEl.find("div:nth-child(2)").data("date");
    let _drawingDateAndumbers = _drawingData[_selectedDate];
    if (_drawingDateAndumbers) {
      viewContext.winningNumbersData = _drawingDateAndumbers;
      viewContext.winningNumbersData.date = _selectedDate;
    }
  }

  dateSelectedByUser(dateEl) {
    let date = dateEl.find("div:nth-child(2)").data("date");
    if (
      dateEl
        .parent()
        .parent()
        .hasClass("cmn__your-numbers__selectors__selector--weeklydrawing")
    ) {
      this.getGameData(this.currentGameId, date);
    } else {
      this.pickedDailyDate = date;
      this.getWinningNumbersData();
      this.filterDrawnData(this.gameData);
      this.renderDrawnNumbers(this.gameData);
      //this.processGameData(this.gameData, true);
    }
  }

  processGameData(data = {}) {
    //everything = 1, weekly = 2, daily = 3;
    this.resetFields();
    this.emptyAllFields();
    this.renderGameMetadata(data);
    this.renderMatchkey(data.matchkey);
    if (data.isWeeklyDrawing) {
      this.renderDateSelector("weekly", data.weeklydrawing);
    }
    this.processDailyDrawingData(data);
  }

  filterDrawnData(data) {
    if (data.drawingData === null) {
      this.renderUserPicks([0]);
    } else {
      let filteredResult = data.drawingData.yourNumbers.filter(function(num) {
        let doesDeviceMatch = false;
        if (viewContext.deviceSelected[0] == "all") {
          doesDeviceMatch = true;
        } else if (viewContext.deviceSelected.length > 1) {
          doesDeviceMatch =
            viewContext.deviceSelected[0] == num.device ||
            viewContext.deviceSelected[1] == num.device;
        } else {
          doesDeviceMatch = viewContext.deviceSelected[0] == num.device;
        }
        let doesDateMatch = viewContext.pickedDailyDate == num.pickedOnDate;
        return doesDeviceMatch && doesDateMatch;
      });

      if (data.isPowerNumber && filteredResult.length === 0) {
        this.filterPowerNumberDrawnData(data);
      } else {
        filteredResult.isPowerNumber = data.isPowerNumber;
        this.renderUserPicks(filteredResult);
      }
    }
  }
  filterPowerNumberDrawnData(data) {
    // let filteredResult = data.dailydrawing.filter(function(drawing) {
    //   return viewContext.pickedDailyDate =
    // })
    //need to get power number from drawing when there are no user picks so grabbing it from the dailydrawing object instead of the picked number object and converting it to match data in nunjucks template
    let filteredResult = [data.dailydrawing[viewContext.pickedDailyDate]];
    filteredResult.isPowerNumber = true;
    filteredResult[0].powerNumber = filteredResult[0].drawnNumbers[0];
    this.renderUserPicks(filteredResult);
  }

  processDailyDrawingData(data) {
    this.renderDateSelector("daily", data.dailydrawing);
    $(
      ".cmn__your-numbers__selectors__selector--dailydrawing .cmn__your-numbers__selectors__selector__optionsEl li:nth-child(2)"
    ).trigger("click");
  }

  renderPick4Matchkey(data) {
    $(".cmn__matchkey__grid__pick4").css({ background: "#" + data.color });
    let dataContainer = $(".cmn__matchkey__grid__pick4-tbl-data-container");
    dataContainer.empty();

    let dataContentHtml = "";
    for (let i = 0; i < data.cashPayout.length; i++) {
      let dataItem = data.cashPayout[i];
      dataContentHtml += `<div class="cmn__matchkey__grid__pick4-tbl-data">
                    <div class="left-column">
                        ${dataItem[0]}
                    </div>
                    <div class="right-column">
                        <div class="inner">
                            $${dataItem[1]}
                        </div>
                    </div>
                </div>`;
    }

    dataContainer.append(dataContentHtml);
  }
  renderPowerNumber(data) {
    $(".cmn__matchkey__grid__pick-number-amount, .c-table--cashmatch").hide();
    $(".cmn__your-numbers__drawn-numbers__number-holder__drawn-on-date").hide();
    $(
      ".cmn__matchkey__token-award .cmn__matchkey__grid__pick-number-amount:first-of-type"
    ).show();
  }

  renderMatchkey(data) {
    $(".cmn__matchkey__grid__pick-number-amount>div>span").html(
      data.pickNumber
    );
    $(".cmn__matchkey .cmn__your-numbers__arrow").css({
      "border-bottom-color": "#" + data.color
    });
    $(".cmn__matchkey").css({ background: "#" + data.color });

    if(typeof(data.tokenPayout) != "undefined" ){
      // show in case hidden below
      $(".cmn__matchkey__token-award").removeClass(
        "cmn__matchkey__hidden"
      );
      // enable header for token and cash
      $(".cmn__matchkey__cash-award-header").addClass("cmn__matchkey__hidden");
      $(".matchkey--hdr").removeClass(
        "cmn__matchkey__hidden"
      );

      $(".cmn__matchkey__grid__pick-number-amount-cash-only").addClass("cmn__matchkey__hidden");

      $(".c-table--tokenmatch").append(
        renderTemplate("cmn/cmn_matchKey.html", {
          matchKeyAwards: data.tokenPayout,
          formatNumber: this.formatNumber,
          isCash: false
        })
      );
    } else
    {
      // hide token table if no tokens returned
      $(".cmn__matchkey__token-award").addClass("cmn__matchkey__hidden");

      // change banner text for cash only
      $(".matchkey--hdr").addClass("cmn__matchkey__hidden");
      $(".cmn__matchkey__cash-award-header").removeClass(
        "cmn__matchkey__hidden"
      );

      $(".cmn__matchkey__grid__pick-number-amount-cash-only").html("Pick " + data.pickNumber);
      $(".cmn__matchkey__grid__pick-number-amount-cash-only").removeClass(
        "cmn__matchkey__hidden"
      );
    }

    $(".c-table--cashmatch").append(
      renderTemplate("cmn/cmn_matchKey.html", {
        matchKeyAwards: data.cashPayout,
        formatNumber: this.formatNumber,
        isCash: true
      })
    );
    if (data.pickNumber === 1) {
      this.renderPowerNumber(data);
    }
    if (data.pickNumber === 4) {
      this.renderPick4Matchkey(data);
    }
  }

  formatNumber(val, decimals = 0) {
    if (isNaN(val)) return val;
    val = parseFloat(val, 10);
    if (decimals) {
      val = val.toFixed(decimals);
    }
    val = "" + val;
    var x = val.split(".");
    var x1 = x[0];
    var x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    return x1 + x2;
  }

  renderDateSelector(type, data) {
    $(
      `.cmn__your-numbers__selectors__selector--${type}drawing .cmn__your-numbers__selectors__selector__optionsEl`
    ).html(
      renderTemplate("cmn/cmn_liSelector.html", {
        isWeekly: type == "weekly",
        dataSet: data
      })
    ); //.find("li:nth-child(2)").trigger("click");
    this.setSelectedDateTo(
      $(
        `.cmn__your-numbers__selectors__selector--${type}drawing .cmn__your-numbers__selectors__selector__optionsEl li:nth-child(2)`
      )
    );
  }

  renderDrawnNumbers(data) {
    if (data.isPowerNumber) {
      $(".cmn__your-numbers__drawn-numbers__number-holder__numbers")
        .first()
        .html(
          renderTemplate("cmn/cmn_drawnNumbers.html", {
            drawnNumbers: this.winningNumbersData.drawnNumbers,
            isWeekly: this.gameData.isWeeklyDrawing,
            isPowerNumber: data.isPowerNumber
          })
        );
      $(
        ".cmn__your-numbers__drawn-numbers__number-holder--power-number-holder__numbers"
      ).html("");
    } else {
      if(data.drawDate) {
        var _date = data.drawDate.split("-");
      } else {
        var _date = this.winningNumbersData.date.split("-");
      }

      let _drawnOrDrawing = "drawing";
      let _drawnDate = `${_date[1]}/${_date[2]}/${_date[0]}`;

      if (this.winningNumbersData.drawnNumbers.length > 0) {
        if (this.winningNumbersData.isFuture === undefined)
          _drawnOrDrawing = "drawn";
      } else {
        if (this.winningNumbersData.isFuture === undefined && !data.drawDate) _drawnDate = `--`;
      }
      $(
        ".cmn__your-numbers__drawn-numbers__number-holder__drawn-on-date span:nth-child(1)"
      ).html(_drawnOrDrawing);
      $(
        ".cmn__your-numbers__drawn-numbers__number-holder__drawn-on-date span:nth-child(2)"
      ).html(_drawnDate);
      $(".cmn__your-numbers__drawn-numbers__number-holder__numbers")
        .first()
        .html(
          renderTemplate("cmn/cmn_drawnNumbers.html", {
            drawnNumbers: this.winningNumbersData.drawnNumbers,
            isWeekly: this.gameData.isWeeklyDrawing,
            isPowerNumber: data.isPowerNumber
          })
        );
      $(
        ".cmn__your-numbers__drawn-numbers__number-holder--power-number-holder__numbers"
      ).html(
        renderTemplate("cmn/cmn_drawnNumbers.html", {
          drawnNumbers: isNaN(
            parseInt(this.winningNumbersData.powerPrizeNumber, 10)
          )
            ? []
            : [this.winningNumbersData.powerPrizeNumber],
          isWeekly: this.gameData.isWeeklyDrawing
        })
      );

      if (this.isFirstGame) {
        AnimationUtil.onAnimationEnd(
          $(".cmn__your-numbers__drawn-numbers__number-holder__numbers")
            .first()
            .find("li:last"),
          true,
          function(e) {
            //console.log("DONE1");
            $(".cmn__your-numbers__drawn-numbers__number-holder__numbers")
              .first()
              .addClass("alreadyAnimated")
              .removeClass("animateNumbers");
            $(
              ".cmn__your-numbers__drawn-numbers__number-holder--power-number-holder__numbers"
            ).addClass("animateNumbers");
          }
        );
        AnimationUtil.onAnimationEnd(
          $(
            ".cmn__your-numbers__drawn-numbers__number-holder--power-number-holder__numbers"
          ).find("li:last"),
          true,
          function(e) {
            //console.log("DONE2");
            $(
              ".cmn__your-numbers__drawn-numbers__number-holder--power-number-holder__numbers"
            )
              .addClass("alreadyAnimated")
              .removeClass("animateNumbers");
          }
        );
        $(".cmn__your-numbers__drawn-numbers__number-holder__numbers")
          .first()
          .addClass("animateNumbers");
      } else {
        $(".cmn__your-numbers__drawn-numbers__number-holder__numbers")
          .addClass("alreadyAnimated")
          .removeClass("animateNumbers");
      }
    }
  }

  renderUserPicks(data) {
    $(".cmn__your-numbers__your-picks tbody").html(
      renderTemplate("cmn/cmn_pickedNumbers.html", {
        pickedNumbers:
          PCHUSER.type == 2
            ? data
            : [PCH.loginUrl, PCH.registrationUrl, PCH.createPasswordUrl],
        userType: PCHUSER.type,
        isFullyRegistered: PCHUSER.isFullyRegistered,
        winningNumbers: this.winningNumbersData.drawnNumbers,
        isMobile: window.isMobile,
        isPowerNumber: data.isPowerNumber,

        existsInArray: function(array, value) {
          return (
            array.filter(function(n) {
              return n == value;
            }).length > 0
          );
        }
      })
    );
  }

  renderGameMetadata(data) {
    data.isWeeklyDrawing
      ? $(".cmn").addClass("is-weekly-drawing")
      : $(".cmn").removeClass("is-weekly-drawing");
    data.isPowerprize
      ? $(".cmn").addClass("is-powerprize")
      : $(".cmn").removeClass("is-powerprize");
    data.isMultiplier
      ? $(".cmn").addClass("is-multiplier")
      : $(".cmn").removeClass("is-multiplier");
    data.isPowerNumber
      ? $(".cmn").addClass("is-powerNumber")
      : $(".cmn").removeClass("is-powerNumber");

    if (data.isPick4) {
      $(".matchkey--hdr").addClass("cmn__matchkey__hidden");
      $(".cmn__matchkey__cash-award-header").removeClass(
        "cmn__matchkey__hidden"
      );

      document
        .querySelector(".cmn__matchkey__grid.cmn__matchkey__grid--tokenmatch")
        .classList.add("cmn__matchkey__hidden");
      document
        .querySelector(".cmn__matchkey__grid__pick4")
        .classList.remove("cmn__matchkey__hidden");
    }
  }

  resetFields() {
    $(".cmn__matchkey__cash-award-header").addClass("cmn__matchkey__hidden");
    $(".matchkey--hdr").removeClass("cmn__matchkey__hidden");

    document
      .querySelector(".cmn__matchkey__grid.cmn__matchkey__grid--tokenmatch")
      .classList.remove("cmn__matchkey__hidden");
    document
      .querySelector(".cmn__matchkey__grid__pick4")
      .classList.add("cmn__matchkey__hidden");

    $(".cmn__matchkey__grid__pick-number-amount, .c-table--cashmatch").show();

    // added to fix power number problem
    $(".cmn__your-numbers__drawn-numbers__number-holder__drawn-on-date").show();
  }

  emptyAllFields() {
    $(
      `.c-table--tokenmatch .c-table__row:not(.c-table__row--heading),
            .c-table--cashmatch .c-table__row:not(.c-table__row--heading)
        `
    ).remove();
  }

  getGameData(gameId, drawingDate) {
    let _DD = drawingDate;
    this.toggleLoadingIcon(1);
    jQuery
      .ajax({
        url: "/cmn/masterdata",
        data: {
          gameId,
          drawingDate
        }
      })
      .done(data => {
        this.gameData = data;
        if (_DD == undefined) {
          this.processGameData(data);
        } else {
          this.processDailyDrawingData(data);
        }
      })
      .fail(data => window.location.reload())
      .always(data => {
        this.toggleLoadingIcon();
      });
  }

  unmount(appCtx) {
    super.unmount(appCtx);
  }
}

export default CheckMyNumbersView;
